import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useTheme from "@material-ui/core/styles/useTheme";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
// @material-ui/lab components
import Skeleton from "@material-ui/lab/Skeleton";
import boxShadows from "assets/theme/box-shadow";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useCardStyles = makeStyles((theme) => ({
  cardRoot: {
    marginBottom: "1rem",
  },
  cardContentRoot: {
    padding: "1rem 1.5rem !important",
  },
  textUppercase: {
    textTransform: "uppercase",
    fontSize: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem !important",
    },
  },
  numberCard: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "5px !important",
    },
  },
  bgIcon: {
    backgroundColor: theme.palette.dark.main,
  },
}));

const BignumberIcon = ({
  color,
  boxShadow,
  iconClass,
  icon,
  bigNumberLoom,
}) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const itemSize = smDown ? "2rem" : "3.5rem";
  const itemIcon = smDown ? "0.9rem" : "1.5rem";
  const itemFont = smDown ? "1rem" : "1.5rem";

  return (
    <Grid
      item
      xs={3}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        width={bigNumberLoom ? itemSize : "3rem"}
        height={bigNumberLoom ? itemSize : "3rem"}
        padding="12px"
        textAlign="center"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="50%"
        boxShadow={boxShadow}
        color={color}
        className={iconClass}
      >
        {icon && typeof icon === "object" ? (
          <Box
            component={icon}
            width={bigNumberLoom ? itemIcon : "1.5rem!important"}
            height={bigNumberLoom ? itemIcon : "1.5rem!important"}
          />
        ) : null}
        {icon && typeof icon === "string" ? (
          <Box
            component="i"
            fontSize={bigNumberLoom ? itemFont : "1.25rem"}
            className={icon}
          />
        ) : null}
      </Box>
    </Grid>
  );
};

export default function Bignumber({
  value,
  label,
  icon,
  onClickLabel,
  iconPosition,
  bgColorIcon,
}) {
  const classes = useCardStyles();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const itemPadding = mdDown ? "0" : "1.5rem 0.75rem";
  const itemFont = mdDown ? "1.5rem" : "3.5rem";

  return (
    <Card
      classes={{ root: classes.cardRoot }}
      elevation={1}
      style={!!bgColorIcon && { padding: itemPadding }}
    >
      <CardContent classes={{ root: classes.cardContentRoot }}>
        <Grid container component={Box} justifyContent="space-between">
          {iconPosition === "left" && (
            <BignumberIcon
              icon={icon}
              boxShadow={boxShadows.boxShadow}
              color={theme.palette.white.main}
              iconClass={classes.bgIcon}
            />
          )}
          <Grid item xs={9} style={{ paddingRight: 0 }}>
            <Box
              component={Typography}
              variant="h5"
              marginBottom="0!important"
              marginTop="0!important"
              className={classes.textUppercase}
              color={theme.palette.stone.dark + "!important"}
              style={{
                cursor: onClickLabel ? "pointer" : "initial",
                textDecoration: onClickLabel ? "underline" : "none",
              }}
              onClick={onClickLabel || null}
            >
              {label}
            </Box>
            <Box
              component={Typography}
              variant="h2"
              fontWeight="600!important"
              marginBottom="0!important"
              marginTop="0!important"
              style={{ fontSize: `${itemFont}` }}
            >
              {value !== null || value !== undefined || value !== "" ? (
                value
              ) : (
                <Skeleton />
              )}
            </Box>
          </Grid>
          {iconPosition !== "left" && (
            <BignumberIcon
              bigNumberLoom
              icon={icon}
              boxShadow={boxShadows.boxShadow}
              color={theme.palette.white.main}
              iconClass={bgColorIcon ? bgColorIcon : classes.bgIcon}
            />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
